import React, { useState } from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Button from 'components/buttons';
import UIInput from 'components/input/input';
import UIInputPW from 'components/input/inputPW';
import UISelect from 'components/selectbox/UISelect';
import CommonUtil from 'utils/CommonUtil';
import codeDataStore from "common/codedata/store/CodeDataStore";
import StringUtil from 'utils/StringUtil';
import BooleanUtil from "utils/BooleanUtil";
import UIUtils from "utils/UIUtils";
import message from "common/message/source/MessageSource";
import userStore from "common/user/store/UserStore";
import UI from "components/UI";
import TbComFile from "domain/main/com/file/TbComFile";
import TbComFileMapngDetail from "../../../../domain/main/com/file/mapng/TbComFileMapngDetail";
import PageLoading from "../../../../components/loading";
import ValidationUtil from "common/validation/util/ValidationUtil";

function ContentsContainer() {
	const location = useLocation();
	const receivedData = (location.state as any)?.data;
	const [memberInfo, setMemberInfo] = useState({});
	const history = useHistory();

	const updateUserForm = React.useRef<HTMLFormElement>(null);
	const [errorCode, setErrorCode] = React.useState<string>("");
	const formId = "updateUserForm";

	// 폼체크 여부 
	const [formCheck,setFormCheck] = useState(false);  
	const [loadFinish,setLoadFinish] = useState(false);

	const [fileInfoList, setFileInfoList] = React.useState<any[]>([]);

	const [confirmedLoginNm , setConfirmedLoginNm] = useState('');
	const [loginFailCnt,setLoginFailCnt] = useState(0) //비밀번호 오류횟수 
	const [userTpCd,setUserTpCd] = useState('');
	const [useYn, setUseYn] = useState(false);
	const [loginNm,setLoginNm] = useState('');   
	const [personId,setPersonId] = useState('');
	const [personNm,setPersonNm] = useState('');
	const [creatDt ,setCreatDt] = useState('');
	const [apprDate ,setApprDate] = useState('');
	const [apprYn ,setApprYn] = useState('');
	const [apprYnNm ,setApprYnNm] = useState('');
	const [bizNo ,setBizNo] = useState('');
	const [corpNm ,setCorpNm] = useState('');
	const [deptNm ,setDeptNm] = useState('');
	const [emailAdres ,setEmailAdres] = useState('');
	const [emailApprYn ,setEmailApprYn] = useState('');
	const [hpNo ,sethpNo] = useState('');
	const [ofcTelNo ,setOfcTelNo] = useState('');
	const [posiNm ,setPosiNm] = useState('');
	const [userTpCdNm ,setUserTpCdNm] = useState('');
	const [writngDt ,setWritngDt] = useState('');
	const [emailApprDate ,setEmailApprDate] = useState('');
	const [emailApprKey ,setEmailApprKey] = useState('');
	const [loginPassword ,setLoginPassword] = useState('');
	const [confirmPassword ,setConfirmPassword] = useState('');
	const [userId ,setUserId] = useState('');

	const [personTask,setPersonTask] = useState('');   //담당업무추가 개선건처리

	//파일정보 선언 
	let [signFileValue] = useState(new TbComFile());
	const [fileValue, setFileValue] = useState(new TbComFile());
  
	//파일업로드 
	const [uploadId, setUploadId] = React.useState("");
    
	//파일업로드 
    const onCreationComplete = function (uploadID: string) {
        setUploadId(uploadID);
    }

	//파일업로드 완료
	const onUploadComplete = () => {
        const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId);
        const arrayNew = dataArray.newFile;
        const arrayDel = dataArray.deleteFile;
		//console.log("arrayNew : "+JSON.stringify(arrayNew));
		//console.log("arrayDel : "+JSON.stringify(arrayDel));

		let fileInfos : {
			FILE_DETAIL_ID:string;
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_STATUS:string;
		}[] = [];

		let fileInfo : {
			FILE_DETAIL_ID:string;
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_STATUS:string;
		};

		

		//파일등록 정보
		arrayNew?.forEach((item, index) => {
			fileInfo = {
				FILE_DETAIL_ID:item.uniqKey,
				ORGINL_FILE_NM:item.originalName,
				STRE_FILE_NM:item.uploadName,
				FILE_SIZE:item.size,
				STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
				FILE_EXTSN:item.extension,
				FILE_STATUS:"ADD"
			}

			fileInfos.push(fileInfo);
		})

		//파일등록 정보
		arrayDel?.forEach((item, index) => {
			fileInfo = {
				FILE_DETAIL_ID:item.uniqKey,
				ORGINL_FILE_NM:item.originalName,
				STRE_FILE_NM:item.uploadName,
				FILE_SIZE:item.size,
				//STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
				STRE_PATH:item.uploadPath ,
				FILE_EXTSN:item.extension,
				FILE_STATUS:"DEL"
			}

			fileInfos.push(fileInfo);
			
		})

		setFileInfoList(fileInfos);
    }

	const onFileUpload = () => {
		if(uploadId){
			window["RAONKUPLOAD"].Transfer(uploadId);
		}
	}

	//비밀번호 유효성 체크
	const checkPassword = (value: any) => {
		let message = '';
	
		if (value == null || (value + "").length === 0) {
		  return message;
		}
		if (value.length < 8) {
		    message = `8자리 이상 입력해 주세요.`;
	
		  return message;
		}
	
		// const regExp = /(?=.*\d{1,50})(?=.*[~`!@#$%\\^&*()-+=]{1,50})(?=.*[a-zA-Z]{1,50}).{8,50}$/;
		const regExp = new RegExp('^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[~`\'":;,.!@#$%^&*()-+=_]).{8,}$');
	
		if (!regExp.test(value)) {
		  message = `영문, 숫자, 특수문자를 혼합하여 입력해 주세요.`;
	
		  return message;
		}
	
		return message;
	  }
	//사용자  등록전 파일업로드 파라미터 체크
	async function userFormCheck(){

		if(ValidationUtil.checkAll()) {
			// 검증이 유효하지 않은 경우
			return;
	    }

		if (posiNm == null || posiNm == "") {
			await UIUtils.alert("직위를 입력해주세요");
			return;
		}

		if (deptNm == null || deptNm == "") {
			await UIUtils.alert("부서를 입력해주세요");
			return;
		}

		if (personTask == null || personTask == "") {
			await UIUtils.alert("담당업무를 입력해주세요");
			return;
		}

		// 이메일
		if (emailAdres == null || emailAdres == "") {
			await UIUtils.alert("이메일을 입력해주세요");
			return;
		}

		// 기업명
		if (corpNm == null || corpNm == "") {
			await UIUtils.alert("기업명을 입력해주세요");
			return;
		}

		if (loginPassword !== confirmPassword) {
			await UIUtils.alert("패스워드가 일치하지 않습니다");
			return;
		}

		if(loginPassword !== confirmPassword){
			await UIUtils.alert("비밀번호가 일치하지 않습니다.");
			return;
		}else{
			let resMsg ='';
			if(loginPassword !=''){
				resMsg = checkPassword(loginPassword);
				if(resMsg != ''){
					await UIUtils.alert(resMsg);
					return;
				}
			}
	
			if(confirmPassword !=''){
				resMsg = checkPassword(confirmPassword);
				if(resMsg != ''){
					await UIUtils.alert(resMsg);
					return;
				}
			}
		}
		
	  
		if(await UIUtils.confirm('저장하시겠습니까?')){

			setFormCheck(true);  //폼 체크 여부 

			onFileUpload();
		}
	};  

	// 파일 업로드 성공여부 체크
	React.useEffect(() => {
		if(fileInfoList && formCheck) {
			let paramUseYn = "";
		if(useYn){
			paramUseYn = "1";
		}else{
			paramUseYn = "0";
		}

		let param = {
			PERSON_ID:personId
			,LOGIN_NM:loginNm
			,USER_ID:userId
			,EMAIL_ADRES:emailAdres
			,PERSON_NM:personNm
			,CHANGE_PSN_ID:""
			,DEPT_NM:deptNm
			,POSI_NM:posiNm
			,OFC_TEL_NO:ofcTelNo
			,HP_NO:hpNo
			,USER_TP_CD:userTpCd
			,USE_YN:paramUseYn
			,PERSON_TASK:personTask
			,LOGIN_PASSWORD:loginPassword
			,CONFIRM_PASSWORD:confirmPassword
			,FILE_ID:getInfo("FILE_ID")
			,FILE_INFO_LIST:fileInfoList
		}
			
//			console.log("param : "+JSON.stringify(param));
			
			//환수정보 저장 
			onClickSave(param);
		}
	}, [fileInfoList])


	// 상세 데이터 가져오기
	async function initCall(paramPersonId){
		let param = {
			"PERSON_ID": paramPersonId
		};

		const response:any = await CommonUtil.execute({
			url:'adm_4110_detail',
			data: param
		})

		let result = response;
		
		if(response != null){
			//데이터 바인딩
			setMemberInfo(result);
			
			setUserTpCd(result.USER_TP_CD);
			setLoginNm(result.LOGIN_NM)
			setPersonNm(result.PERSON_NM);
			setDeptNm(result.DEPT_NM);
			setPosiNm(result.POSI_NM);
			setBizNo(result.BIZ_NO);
			setCorpNm(result.CORP_NM);
			sethpNo(result.HP_NO);
			setEmailAdres(result.EMAIL_ADRES);
			setOfcTelNo(result.OFC_TEL_NO);
			setUserId(result.USER_ID);
			setApprDate(result.APPR_DATE);
			setApprYn(result.APPR_YN);
			setPersonTask(result.PERSON_TASK);

			if(result.USE_YN == 1){
				setUseYn(true);
			}else {
				setUseYn(false);
			}

			if(result.APPR_YN == "1"){
				setApprYn("1");
			}else{
				setApprYn("0");
			}
			//비밀번호 오류횟수 가져오기
			userLoginFailrAction("select" , result.LOGIN_NM);

			let fileInfoList = result.FILE_INFO_LIST;

			//싸인이미지 있을경우
			//@ts-ignore
			if(fileInfoList!= null){
				const tempFileValue = new TbComFile();
				fileInfoList?.forEach((item, index) => {
					const fileDetail = new TbComFileMapngDetail();
					fileDetail.setDwldId(item.DWLD_ID);
					fileDetail.setFileDetailId(item.FILE_DETAIL_ID);
					fileDetail.setFilePolicy(item.FILE_POLICY);
					fileDetail.setFileRpstr(item.FILE_RPSTR);
					fileDetail.setStrePath(item.STRE_PATH);
					fileDetail.setStreFileNm(item.STRE_FILE_NM);
					fileDetail.setOrginlFileNm(item.ORGINL_FILE_NM);
					fileDetail.setFileExtsn(item.FILE_EXTSN);
					fileDetail.setFileSize(Number(item.FILE_SIZE));
					fileDetail.setRegistDt(item.REGIST_DT);
					fileDetail.setRegistPsnNm(item.REGIST_PSN_NM);
	
					tempFileValue.putTbComFileMapngDetailList(fileDetail);
				})
				setFileValue(tempFileValue);
			}
			setLoadFinish(true);
		}
	
	};

	//상세정보 값 가지고 오기
	function getInfo(name){
		if(Object.keys(memberInfo).length != 0){
			return memberInfo[name];
		}else{
			return '';
		}
	};

	 //====== 유저 로그인 실패횟수 액션 START
	 async function userLoginFailrAction(sAction:string , pLoginNm:string) {
		//파라미터 
		let param = {
			"LOGIN_NM": pLoginNm
		};

		//5회 오류 해제시 사용액션
		if(sAction =="updateZero"){
			if (!window.confirm("비밀번호오류횟수를 초기화 하시겠습니까?")) {
				return;
			}
		}

		// 전송
		const response:any = await CommonUtil.execute({
			url:"adm_4110_TbSysUserLoginFailr_"+ sAction,
            data: param
        })

		//비밀번호 오류횟수
		//console.log(' FAILR_CO : '+ response.FAILR_CO);  
		
		if (sAction == "select") {         //비밀번호 오류 횟수 조회
			setLoginFailCnt(response.FAILR_CO); //비밀번호 오류횟수 저장
	    }else if(sAction =="updateZero"){  //비밀번호 오류 횟수 초기화
			if (response != null) {
				UIUtils.alert('로그인횟수가 초기화 되었습니다.').then();
				//비밀번호 오류횟수 초기화
				setLoginFailCnt(0);     //초기화 0
			}
		}
    }
  
	//목록으로 
	const goList = () =>{
		history.push({
			pathname: './adm4100',    //저장후 상세페이지로 이동
			state: { data: receivedData }
		});
	}

	//취소 상세페이지로 이동
	const pageCancel = function (){
		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
			pathname: './adm4110',
			state: { data: receivedData }
		});
	}

	/**
   * 아이디 중복 체크
   *
   */
	async function checkduplicatedId(event) {
		event.preventDefault();

		if (loginNm == null || StringUtil.isEmpty(loginNm)) {
		  UIUtils.alert(message.get("admin.appmanage.personmanage.pleaseInputId", "아이디를 입력해주세요")).then();
		  return;
		}
		
		const response:any = await CommonUtil.execute({
            url:"checkduplicatedId",
            data: { "LOGIN_NM" : loginNm}
        })

		const result = response.TOTAL;

		if (result == null) {
		  return;
		}
	
		if (result > 0) {
		  UIUtils.alert(message.get("admin.appmanage.personmanage.checkDuplicatedId.failure", "중복된 아이디입니다.")).then();
		  return;
		}else{
			UIUtils.alert(message.get("admin.appmanage.personmanage.checkDuplicatedId.success", "등록 가능한 아이디입니다.")).then();
			setConfirmedLoginNm(loginNm);
		}
		
	}


	//사용자 등록 저장
    async function onClickSave(sendParam) {
		const response:any = await CommonUtil.execute({
			url: "newUserUpdate.jct",
			form: updateUserForm.current as HTMLFormElement,
			data:{
				FILE_INFO_LIST:fileInfoList
			}
		}).then((response:any) => {
			//UIUtils.alert("저장 되었습니다.")
			//.then(() => {
				//초기화
				setFormCheck(false);

				history.push({
					pathname: './adm4110',
					state: { data: receivedData }
				});	
			//});

			
		}).catch(err => {
			CommonUtil.showAxiosError(err);
			return;
		});
    };  


	//상세페이지 로딩시 해야할 것
	//비밀번호 오류횟수 , 권한등록 ,사업지정 , 출엽기업 승인, 이메일 인증발송
	React.useEffect(() => {

		//필요한 공통코드 로딩.
		codeDataStore.read("/system.personmanage/utc", "/common/useYn").then(()=>{
			if(receivedData != undefined){
				let vPersonId = StringUtil.defaultString(receivedData.vPERSON_ID);
				setPersonId(vPersonId)
				localStorage.setItem("personId", vPersonId);
				//상세데이터 가지고 오기
				initCall(vPersonId);
			}
			
			let personIdStorage = localStorage.getItem("personId");
			if (personIdStorage != null) {
				setPersonId(personIdStorage);
			}
		});
		        		
    },[])

	if(!loadFinish)
		return (
			<PageLoading />
		)
	else
	return (
		<PageContainer>
			<LayoutAside />
			<div className="fww-con">
				<ul className="fww-brd">
					<li><Link to="/admin">홈</Link></li>
					<li><Link to="#">관리자페이지</Link></li>
					<li><Link to="#">사용자관리</Link></li>
					<li><Link to="#">회원관리</Link></li>
				</ul>
				<main className="fww-main">
					<h1 className="tx tx-hd2">회원정보 수정</h1>
					<form className="fo fo-col2" id={formId} name={formId} ref={updateUserForm}>

						<UIInput type="hidden" attrs={{name: "FILE_ID"}} value={getInfo("FILE_ID")} />
						<UIInput type="hidden" attrs={{name: "PERSON_ID"}} value={personId} />
						
						<div className="inner">
							<div className="fo-item req">
								<p className="fo-key">사용자 유형</p>
								<div className="fo-value">
									<div className="sl sl-md">
										<UISelect
											codeData={ codeDataStore.get('/system.personmanage/utc')}
											value={userTpCd}
											valueChanged={(value) => {setUserTpCd(value)}}
											attrs={{name:"USER_TP_CD"}}
											rules = {["required"]}
										/>
									</div>
								</div>
							</div>
							<div className="fo-item req">
								<p className="fo-key">사용자ID</p>
								<div className="fo-value">
									<div className="hz-root hz-gap8">
										<UIInput className={'hz-item hz-fg tf tf-md w200'} value={ loginNm } placeholder={'사용자ID'} valueChanged={(value) => {setLoginNm(value)}} rules={['required']} attrs={{name:"LOGIN_NM"}}/>
										<Button color="gray-o" size="md" onClick={(e) => checkduplicatedId(e)}>중복 확인</Button>
									</div>
								</div>
							</div>
							<div className="fo-item req">
								<p className="fo-key">사용자명</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={personNm} placeholder={'사용자명'} valueChanged={(value) => {setPersonNm(value)}} rules={['required']} attrs={{name:"PERSON_NM"}}/>
								</div>
							</div>
							<div className="fo-item req">
								<p className="fo-key">기업명</p>
								<div className="fo-value">
								    <UIInput className={'tf tf-md w100p'} placeholder={'기업명'}  value={corpNm} valueChanged={(value) => {setCorpNm(value)}} rules={['required']} attrs={{name:"CORP_NM"}}/>
								</div>
							</div>
							<div className="fo-item req">
								<p className="fo-key">부서</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={deptNm} placeholder={'부서'} valueChanged={(value) => {setDeptNm(value)}} rules={['required']} attrs={{name:"DEPT_NM"}}/>
								</div>
							</div>
							<div className="fo-item req">
								<p className="fo-key">담당업무</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={personTask} placeholder={'담당업무'} valueChanged={(value) => {setPersonTask(value)}} rules={['required']} attrs={{name:"PERSON_TASK"}}/>
								</div>						
							</div>
							<div className="fo-item req">
								<p className="fo-key">직급</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={posiNm} placeholder={'직급'} valueChanged={(value) => {setPosiNm(value)}} rules={['required']} attrs={{name:"POSI_NM"}}/>
								</div>
							</div>
							<div className="fo-item req">
								<p className="fo-key">휴대폰번호</p>
								<div className="fo-value">
									<UIInput type={'number'} className={'tf tf-md w100p'} value={hpNo} placeholder={'-없이 숫자만'} valueChanged={(value) => {sethpNo(value)}} rules={['required']} attrs={{name:"HP_NO"}}/>
								</div>
							</div>
							<div className="fo-item req">
								<p className="fo-key">이메일</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={emailAdres} placeholder={'이메일'} valueChanged={(value) => {setEmailAdres(value)}} rules={['required']} attrs={{name:"EMAIL_ADRES"}}/>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">사무실전화번호</p>
								<div className="fo-value">
									<UIInput type={'number'} className={'tf tf-md w100p'} value={ofcTelNo} placeholder={'-없이 숫자만'} valueChanged={(value) => {setOfcTelNo(value)}} attrs={{name:"OFC_TEL_NO"}}/>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">이메일 인증</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={getInfo("EMAIL_APPR_YN")=="1"?"예":"아니오"} placeholder={''} readOnly={true}/>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">인증일시</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={getInfo("EMAIL_APPR_DATE")} placeholder={''} readOnly={true}/>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">비밀번호오류횟수</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={loginFailCnt==null?"0":loginFailCnt} placeholder={''} readOnly={true}/>
								</div>
							</div>

							<div className="fo-item">
								<p className="fo-key">승인일자</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={StringUtil.defaultString(getInfo("APPR_DATE"))} readOnly={true}/>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">승인여부</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={apprYn=="1"?"예":"아니오"} readOnly={true}/>
								</div>
							</div>

							<div className="fo-item req">
								<p className="fo-key">사용여부</p>
								<div className="fo-value">
									<div className="sl sl-md">
										<UISelect 
										   value={useYn}
										   valueChanged={(value) => setUseYn(BooleanUtil.toBoolean(value))}
										   codeData={codeDataStore.get("/common/useYn")}
											attrs={{name:"USE_YN"}}
											rules = {["required"]}
										/>	
									</div>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">등록자</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={StringUtil.defaultString(getInfo("PERSON_NM"))} placeholder={''} readOnly={true}/>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">등록일시</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={StringUtil.defaultString(getInfo("WRITNG_DT"))} placeholder={''} readOnly={true}/>
								</div>
							</div>	
							<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">비밀번호</p>
									<div className="fo-value">
										<div className="hz-root hz-gap8">
											<UIInputPW
                                                className={'tf tf-big w100p'}
                                                placeholder={'수정할 때만 입력해주세요'}
                                                attrs={{
                                                    name: "LOGIN_PASSWORD",
                                                    alt: "Password",
                                                    tabIndex: 1,
                                                    autoComplete: "on",
                                                }}
                                                readOnly={false}
                                                valueChanged={(value) => setLoginPassword(value)}
                                               // rules={["required","password"]}
                                                focusClear={true}
                                            />
											
										</div>
										<span className="fc-err">&nbsp;&nbsp;※ 8~12자의 영문, 숫자, 특수문자 조합으로 입력해 주세요.</span>
									</div>
								</div>
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">비밀번호 확인</p>
									<div className="fo-value">
										<div className="hz-root hz-gap8">
										    <UIInputPW
                                                className={'tf tf-big w100p'}
                                                placeholder={'수정할 때만 입력해주세요'}
                                                attrs={{
                                                    name: "CONFIRM_PASSWORD",
                                                    alt: "Password",
                                                    tabIndex: 2,
                                                    autoComplete: "on",
                                                }}
                                                readOnly={false}
                                                valueChanged={(value) => setConfirmPassword(value)}
                                              //  rules={["required","password"]}
                                                focusClear={true}
                                            />
											
										</div>
										<span className="fc-err">&nbsp;&nbsp;※ 8~12자의 영문, 숫자, 특수문자 조합으로 입력해 주세요.</span>
									</div>
								</div>

								<div className="fo-item fo-m-1-3">
									<p className="fo-key">싸인이미지</p>
									<div className="fo-value">
										<div className="inner w100p">
												<UI.FileUpload
												    value={fileValue}
													onCreationComplete={onCreationComplete}
													onUploadComplete={onUploadComplete}
													attrs={{
														MaxTotalFileCount: "1",
														ExtensionAllowOrLimit: "1",
														ImgPreView: "1", 
														Views: "thumbs",
														ExtensionArr: "gif,png,jpg,jpeg"
													}}
												/>
										</div>
									</div>	
							    </div>			

						</div> 
					</form>		
				<div className="hz-root hz-right hz-gap5">
						<Button color="gray-o" size="sm" onClick={pageCancel}>취소</Button>
						<Button color="pri-o" size="sm" onClick={userFormCheck}>저장</Button>
						<Button color='gray-o' size="sm" onClick={goList}>목록</Button>
					</div>

				</main>

			</div>
		</PageContainer>
	);
}
export default ContentsContainer;
